module.exports = __webpack_public_path__ + "dd363f4ee3ba4e5b0fa79e1e1231c3a8.png";